// extracted by mini-css-extract-plugin
export default {"slider":"MyClients_slider__-VKeb","logos":"MyClients_logos__sR7yJ","sliderWrapper":"MyClients_sliderWrapper__w6xxF"};